import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import smoothScroll from 'smoothscroll';

import './Footer.css';

export default class Footer extends React.Component {

  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('Footer', this.props.className)}>
        <div className="Footer__companyContainer">
          <div className="Footer__company">
            <FormattedMessage id="Footer.hansuk"/>
          </div>
        </div>
        <div className="Footer__topContainer">
          <div
            className="Footer__top"
            onClick={this._onClickUpArrow}>
            <div className="Footer__upArrowIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                <path d="M11.75,31.0600448 L11.75,1 C11.75,0.585786438 11.4142136,0.25 11,0.25 C10.5857864,0.25 10.25,0.585786438 10.25,1 L10.25,31.0600448 L1.55495506,21.4954954 C1.27632486,21.1890022 0.801988618,21.1664148 0.495495405,21.4450449 C0.189002191,21.7236751 0.166414751,22.1980114 0.445044945,22.5045046 L11,34.1149552 L21.5549551,22.5045046 C21.8335852,22.1980114 21.8109978,21.7236751 21.5045046,21.4450449 C21.1980114,21.1664148 20.7236751,21.1890022 20.4450449,21.4954954 L11.75,31.0600448 Z" transform="rotate(-180 16.5 20)"/>
              </svg>
            </div>
            <FormattedMessage id="Footer.top"/>
          </div>
        </div>
        <div className="Footer__copyrightContainer">
          <div className="Footer__copyright">
            <FormattedMessage id="Footer.copyright"/>
          </div>
        </div>
        <div className="Footer__navylabContainer">
          <div className="Footer__navylab">
            <FormattedMessage id="Footer.navylab"/>
          </div>
        </div>
      </div>
    );
  }

  _onClickUpArrow = () => {
    const anchor = document.querySelector('.Hero');
    smoothScroll(anchor);
  };

}



// WEBPACK FOOTER //
// ./src/components/Footer.js